export default "__VITE_ASSET__BYrzQyro__"